import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { setDsrPages, updateDsr } from '../actions/dsr-actions'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrRepublishModal({
  dsrId,
  dsrPages,
  handleCloseModal,
  //Actions
  updateDsr,
  setDsrPages,
  // Redux
  updateDsrOutcome
}) {


  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent } = updateDsrOutcome || {};

      if (updateDsrStatus && sourceEvent === "republish-dsr") {
        redirectToNewPage(`/dsr/${dsrId}`)
      }
    }

  }, [updateDsrOutcome, dsrId]);

  const handleClickRepublishButton = () => {
    setShowLoader(true);
    setDsrPages(dsrPages)
    updateDsr({
      dsrId,
      dsrPages,
      status: 'active',
      sourceEvent: "republish-dsr"
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Room members will soon be able to view the contents again. Proceed?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleClickRepublishButton()} label='Yes, publish again' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={'You are about to re-publish it'}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      setDsrPages
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrRepublishModal));
